// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"22":"274d5243","26":"ea24a1e5","242":"274d5243","488":"c2449bda","740":"bf65452a"}[chunkId] + ".css";
};